import { useEffect } from 'react'

export default function useDelay (cb, delay = 0, dependencies = []) {
  useEffect(() => {
    setTimeout(cb, delay)
  }, dependencies)
}
